/* eslint-disable max-len */
import React, { useMemo } from 'react'
import styles from './index.module.less'
import { useTranslation } from '@sailor/i18n-web'
import HighlightText from '@/components/HighlightText'
import Container from '@/components/Container'
import { Link, useLocation } from 'react-router-dom'
import { useLang } from '@/common/utils/i18n'
import { getDangerHtmlText } from '@/common/utils'
import { INewDetailData, newsItem } from './newsText'

// NOTE: 后期可以改为远程数据https://horn-hk.mykeeta.com/horn_ios?from=e_pc_official_infomation&os=ios_test&version=v1


function getI18nObj (data: INewDetailData, keyPrefix: string, lang:string) {
  const langKey = lang === 'en' ? 'En' : 'Zh'
  const targetKey = `${keyPrefix}${langKey}`
  // @ts-ignore
  return data[targetKey] || data[`${keyPrefix}En`] || data[`${keyPrefix}Zh`] || data['keyPrefix']
}

const Infomation = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const currentLang = useLang()
  const newsDetail = useMemo(() => {
    const locationNewsIndex =  new URLSearchParams(location.search).get('index')
    if (locationNewsIndex) {
      return newsItem[Number(locationNewsIndex)]
    }
    return ''
  }, [location.search])


  return (
    <Container>
      <div style={{ width: '100%' }} className={styles.pageWraper}>
        <div className="section-title">
          <HighlightText>{t('ent_o_title_info1', '资讯')}</HighlightText>
          <span>{t('ent_o_title_center1', '中心')}</span>
        </div>
        <div className={styles.container} style={{ height: newsDetail ? '0' : 'auto', overflowY: 'hidden' }}>
          <div style={{ width: '100%', paddingTop: '9.6rem' }}>
            <div className={styles.scrollWrapper}>
              {
                newsItem.map((item, index) => (
                  <div className={styles.card}>
                    <div style={{ backgroundImage: `url(${item.img})` }} className={styles.cardImg}/>
                    <div className={styles.cardContent}>
                      <div className={`${styles.cardTitle}`} > {getI18nObj(item, 'title', currentLang)} </div>
                      <div  style={{ paddingTop: '3.2rem' }}>
                        {
                          item.link
                            ? <a href={item.link} target="_blank" > {t('ent_o_action_learn_more', '了解更多')} </a>
                            : <Link to={`/information?index=${index}`}> {t('ent_o_action_learn_more', '了解更多')}</Link>
                        }
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
        {newsDetail && (<NewsDetail newsDetail={newsDetail}/>)}
      </div>
    </Container>
  )
}

function  NewsDetail (props: {newsDetail: INewDetailData}) {
  const currentLang = useLang()
  const { t } = useTranslation()
  const { newsDetail } = props

  return (
    <div className={styles.newsDetail}>
      <Link to={'/information'}> {t('ent_o_action_back', '返回')}</Link>
      <div style={{ paddingTop: '6.4rem' }}>
        <img src={newsDetail.img} style={{ height: '40rem' }} alt="" />
        <div  className={styles.newsDetailTitle}
          dangerouslySetInnerHTML={getDangerHtmlText(getI18nObj(newsDetail, 'title', currentLang))} />
        <div  className={styles.newsDetailContent}
          dangerouslySetInnerHTML={getDangerHtmlText(getI18nObj(newsDetail, 'content', currentLang))} />
      </div>
    </div>
  )
}


export default Infomation